import { render, staticRenderFns } from "./serverEdit.vue?vue&type=template&id=42596e9d&scoped=true&"
import script from "./serverEdit.vue?vue&type=script&lang=js&"
export * from "./serverEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42596e9d",
  null
  
)

export default component.exports